import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Courses from "@/pages/Courses";
import CourseDetail from "@/pages/CourseDetail";
import Users from "@/pages/Users";
import Groups from "@/pages/Groups";
import Gradebook from "@/pages/Gradebook";
import Messages from "@/pages/Messages";
import AIAssistant from "@/pages/AIAssistant";
import AtelierIA from "@/pages/AtelierIA";
import Decrochage from "@/pages/Decrochage";
import Academic from "@/pages/Academic";
import Bibliotheque from "@/pages/Bibliotheque";
import BureauEnseignants from "@/pages/BureauEnseignants";
import SallesDeCours from "@/pages/SallesDeCours";
import EspacesEtudiants from "@/pages/EspacesEtudiants";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/app"
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="cours" element={<Courses />} />
              <Route path="cours/:id" element={<CourseDetail />} />
              <Route
                path="utilisateurs"
                element={
                  <Protected roles={["admin"]}>
                    <Users />
                  </Protected>
                }
              />
              <Route
                path="groupes"
                element={
                  <Protected roles={["admin"]}>
                    <Groups />
                  </Protected>
                }
              />
              <Route
                path="academique"
                element={
                  <Protected roles={["admin"]}>
                    <Academic />
                  </Protected>
                }
              />
              <Route
                path="atelier-ia"
                element={
                  <Protected roles={["admin", "professeur"]}>
                    <AtelierIA />
                  </Protected>
                }
              />
              <Route
                path="decrochage"
                element={
                  <Protected roles={["admin", "professeur"]}>
                    <Decrochage />
                  </Protected>
                }
              />
              <Route path="salles" element={<SallesDeCours />} />
              <Route path="bibliotheque" element={<Bibliotheque />} />
              <Route path="enseignants" element={<BureauEnseignants />} />
              <Route path="espaces" element={<EspacesEtudiants />} />
              <Route
                path="notes"
                element={
                  <Protected roles={["etudiant"]}>
                    <Gradebook />
                  </Protected>
                }
              />
              <Route path="messagerie" element={<Messages />} />
              <Route path="assistant" element={<AIAssistant />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
